export const motionTokens = {
  duration: {
    micro: 0.2,
    quick: 0.36,
    supporting: 0.46,
    reveal: 0.52,
    hero: 0.62,
    deliberate: 0.65,
  },
  easing: {
    entrance: [0.22, 1, 0.36, 1],
    micro: [0.2, 0, 0, 1],
    linear: [0, 0, 1, 1],
  },
  distance: {
    compact: 8,
    subtle: 14,
    standard: 16,
    package: 18,
    hero: 20,
    editorial: 24,
  },
  stagger: {
    tight: 0.065,
    standard: 0.07,
    heroLine: 0.08,
    process: 0.09,
  },
  delay: {
    outputCards: 0.16,
    identityPillars: 0.18,
    cardSignal: 0.22,
    cardRule: 0.3,
    heroLede: 0.32,
    heroActions: 0.4,
    pricingCards: 0.1,
    pricingRule: 0.72,
    resolutionCards: 0.52,
    resolutionCta: 1.25,
  },
  breakpoint: {
    mobile: 760,
    compactDesktop: 1100,
  },
  viewport: {
    desktop: {
      amount: "some",
      triggerRatio: 0.68,
    },
    mobile: {
      amount: "some",
      triggerRatio: 0.82,
    },
  },
};
